import { compose, setDisplayName } from 'recompact';

import { errorBoundary } from 'src/app/hocs';

import Renderer from '.';

export default compose(setDisplayName('DeliveryItems'), errorBoundary)(Renderer);
